import * as React from 'react';

import type { PersonalizedData } from 'bundles/degree-description/types';

export type DegreeDescriptionPersonalizationContextType = {
  personalizedDdpData?: PersonalizedData;
};

export const DegreeDescriptionPersonalizationContext = React.createContext<
  DegreeDescriptionPersonalizationContextType | undefined
>(undefined);

export const useDegreeDescriptionPersonalizedData = () => {
  const context = React.useContext(DegreeDescriptionPersonalizationContext);
  if (!context)
    throw new Error('useDegreeDescriptionPersonalizedData was used outside of DegreeDescriptionPersonalizationContext');
  return context;
};

export default DegreeDescriptionPersonalizationContext;
